export default {
	UPDATE_USER: 'users/update',
	CHATS: {
		MESSAGE: 'chats/message',
		DELETE: 'chats/delete',
		EDIT: 'chats/edit'
	},
	CLAIM_CHATS: {
		MESSAGE: 'chats/claim-message',
	},
}